module.exports = __webpack_public_path__ + "static/img/write_off_img.5b4fdce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/write_off_img.png
// module id = KOPT
// module chunks = 59